import { getPlatformType, PlatformType } from '@shopee-user/platform';

export const isIOS = () => getPlatformType() === PlatformType.iOS;
